export default "__VITE_ASSET__64786300__"